module.exports = __webpack_public_path__ + "media/assets/mobileHeader-d21af05c51287f4f682b7728a9f0bd09.png";